import Tile from './Tile';

export * from './TileProps';
export default Tile;
